(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animation-series-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var apiPromise;

    function loadYouTubeApi() {
      if (window.YT && window.YT.Player) {
        return Promise.resolve(window.YT);
      }

      if (apiPromise) {
        return apiPromise;
      }

      apiPromise = new Promise(function (resolve) {
        var previousReady = window.onYouTubeIframeAPIReady;

        window.onYouTubeIframeAPIReady = function () {
          if (typeof previousReady === 'function') {
            try { previousReady(); } catch (e) {}
          }

          resolve(window.YT);
        };

        if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
          var script = document.createElement('script');
          script.src = 'https://www.youtube.com/iframe_api';
          script.async = true;
          document.head.appendChild(script);
        }
      });

      return apiPromise;
    }

    function setupSection(section) {
      if (!section || section.dataset.animationPlaybackReady === 'true') {
        return;
      }

      section.dataset.animationPlaybackReady = 'true';

      var htmlVideos = Array.prototype.slice.call(section.querySelectorAll('video'));
      var youtubePlayers = [];

      function pauseEverythingExcept(active) {
        htmlVideos.forEach(function (video) {
          if (video !== active && !video.paused) {
            try { video.pause(); } catch (e) {}
          }
        });

        youtubePlayers.forEach(function (player) {
          if (player !== active) {
            try { player.pauseVideo(); } catch (e) {}
          }
        });
      }

      htmlVideos.forEach(function (video) {
        video.addEventListener('play', function () {
          pauseEverythingExcept(video);
        }, { passive: true });
      });

      section.querySelectorAll('[data-animation-youtube-facade]').forEach(function (facade, index) {
        facade.addEventListener('click', function () {
          if (facade.dataset.youtubeLoaded === 'true') {
            return;
          }

          facade.dataset.youtubeLoaded = 'true';

          var videoId = facade.dataset.youtubeId;
          var shouldLoop = facade.dataset.youtubeLoop === 'true';

          if (!videoId) {
            return;
          }

          pauseEverythingExcept(null);

          var params = [
            'autoplay=1',
            'playsinline=1',
            'rel=0',
            'modestbranding=1',
            'enablejsapi=1'
          ];

          if (shouldLoop) {
            params.push('loop=1');
            params.push('playlist=' + encodeURIComponent(videoId));
          }

          var iframe = document.createElement('iframe');
          iframe.className = 'animation-series__iframe';
          iframe.id = 'AnimationYoutube-' + section.id.replace(/[^a-zA-Z0-9_-]/g, '') + '-' + index;
          iframe.src =
            'https://www.youtube-nocookie.com/embed/' +
            encodeURIComponent(videoId) +
            '?' +
            params.join('&');
          iframe.title = facade.getAttribute('aria-label') || 'Play animation';
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen';
          iframe.allowFullscreen = true;

          facade.replaceWith(iframe);

          loadYouTubeApi().then(function (YT) {
            var player = new YT.Player(iframe, {
              events: {
                onStateChange: function (event) {
                  if (event.data === YT.PlayerState.PLAYING) {
                    pauseEverythingExcept(event.target);
                  }
                }
              }
            });

            youtubePlayers.push(player);
          });
        }, { once: true });
      });
    }

    function init(root) {
      (root || document)
        .querySelectorAll('[data-animation-series]')
        .forEach(setupSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      }, { once: true });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artist-cart-items"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var syncTimer = null;
    var syncInFlight = false;

    function rootUrl() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
      return '/';
    }

    function syncCustomCartCount() {
      if (syncInFlight) return;

      syncInFlight = true;

      fetch(rootUrl() + 'cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to refresh cart count');
          return response.json();
        })
        .then(function (cart) {
          var count = Number(cart.item_count || 0);

          document.querySelectorAll('cart-items.artist-cart').forEach(function (cartRoot) {
            cartRoot.classList.toggle('is-empty', count <= 0);
          });

          document.querySelectorAll('.artist-header__cart-count, [data-cart-count]').forEach(function (node) {
            node.textContent = count;

            if (node.classList.contains('artist-header__cart-count')) {
              node.classList.toggle('is-hidden', count <= 0);
            }

            node.setAttribute('aria-label', count + (count === 1 ? ' item in cart' : ' items in cart'));
          });

          document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
            bubble.classList.toggle('hidden', count <= 0);

            var visibleCount = bubble.querySelector('span[aria-hidden="true"], .count');
            if (visibleCount) visibleCount.textContent = count;
          });

          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              detail: {
                cart: cart
              }
            })
          );
        })
        .catch(function () {
          /* Keep cart interaction usable even if count refresh fails. */
        })
        .finally(function () {
          syncInFlight = false;
        });
    }

    function scheduleCountSync() {
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(syncCustomCartCount, 80);
    }

    function patchCartItems() {
      if (!window.customElements || !customElements.get('cart-items')) return false;

      var CartItemsElement = customElements.get('cart-items');
      var prototype = CartItemsElement && CartItemsElement.prototype;

      if (!prototype || prototype.__artistCartCompatibilityPatched) return true;

      prototype.__artistCartCompatibilityPatched = true;

      prototype.getSectionsToRender = function () {
        var sections = [];

        var items = document.getElementById('main-cart-items');
        if (items && items.dataset.id) {
          sections.push({
            id: 'main-cart-items',
            section: items.dataset.id,
            selector: '.js-contents'
          });
        }

        var standardHeaderBubble = document.getElementById('cart-icon-bubble');
        if (standardHeaderBubble) {
          sections.push({
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section'
          });
        }

        var liveRegion = document.getElementById('cart-live-region-text');
        if (liveRegion) {
          sections.push({
            id: 'cart-live-region-text',
            section: 'cart-live-region-text',
            selector: '.shopify-section'
          });
        }

        var footer = document.getElementById('main-cart-footer');
        if (footer && footer.dataset.id) {
          sections.push({
            id: 'main-cart-footer',
            section: footer.dataset.id,
            selector: '.js-contents'
          });
        }

        return sections;
      };

      document.querySelectorAll('cart-items').forEach(function (cartItems) {
        if (cartItems.__artistCartObserver) return;

        var contents = cartItems.querySelector('#main-cart-items .js-contents');
        if (!contents) return;

        var observer = new MutationObserver(function () {
          scheduleCountSync();
        });

        observer.observe(contents, {
          childList: true,
          subtree: true
        });

        cartItems.__artistCartObserver = observer;
      });

      return true;
    }

    function init() {
      if (patchCartItems()) return;

      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('cart-items').then(function () {
          patchCartItems();
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function () {
      patchCartItems();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artist-new-contact"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initArtistContact(section) {
    if (!section || section.dataset.artistContactInitialized === 'true') return;

    var form = section.querySelector('[data-artist-contact-form]');
    var honeypot = section.querySelector('[data-artist-contact-honeypot]');
    var messageField = section.querySelector('[data-artist-contact-message]');
    var spamError = section.querySelector('[data-artist-contact-spam-error]');

    if (!form || !honeypot || !messageField || !spamError) return;

    section.dataset.artistContactInitialized = 'true';

    messageField.addEventListener('input', function() {
      if (messageField.value.trim().length >= 10) {
        messageField.setCustomValidity('');
        spamError.hidden = true;
      }
    });

    form.addEventListener('submit', function(event) {
      var honeypotFilled = honeypot.value && honeypot.value.trim() !== '';
      var messageTooShort = messageField.value.trim().length < 10;

      spamError.hidden = true;

      if (messageTooShort) {
        messageField.setCustomValidity('Please add a little more detail.');
        messageField.reportValidity();
        event.preventDefault();
        spamError.hidden = false;
        return;
      }

      messageField.setCustomValidity('');

      if (honeypotFilled) {
        event.preventDefault();
        spamError.hidden = false;
      }
    });
  }

  function initializeArtistContacts(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('[data-artist-contact]')) {
      initArtistContact(scope);
    }

    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-artist-contact]'),
      initArtistContact
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeArtistContacts(document);
    }, { once: true });
  } else {
    initializeArtistContacts(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initializeArtistContacts(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artist-policy-legal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function textLooksLikeQuestion(element) {
      if (!element || !element.textContent) return false;
      return element.textContent.trim().endsWith('?');
    }

    function isBoldQuestion(element) {
      if (!element || element.nodeType !== 1 || element.tagName !== 'P') return false;

      var first = element.firstElementChild;
      if (!first) return false;

      return (
        (first.tagName === 'STRONG' || first.tagName === 'B') &&
        element.textContent.trim().length > 0
      );
    }

    function isHeadingQuestion(element) {
      if (!element || element.nodeType !== 1) return false;
      return /^H[2-6]$/.test(element.tagName);
    }

    function isQuestionElement(element, mode) {
      if (!element || element.nodeType !== 1) return false;

      if (mode === 'headings') {
        return isHeadingQuestion(element);
      }

      if (mode === 'bold') {
        return isBoldQuestion(element);
      }

      if (mode === 'question-mark') {
        return element.tagName === 'P' && textLooksLikeQuestion(element);
      }

      return (
        isHeadingQuestion(element) ||
        isBoldQuestion(element) ||
        (element.tagName === 'P' && textLooksLikeQuestion(element))
      );
    }

    function directQuestionCount(container, mode) {
      return Array.prototype.slice.call(container.children).filter(function (child) {
        return isQuestionElement(child, mode);
      }).length;
    }

    function findQuestionContainer(source, mode) {
      var queue = [source];
      var fallback = null;

      while (queue.length) {
        var container = queue.shift();
        var count = directQuestionCount(container, mode);

        if (count >= 2) {
          return container;
        }

        if (!fallback && count === 1) {
          fallback = container;
        }

        Array.prototype.slice.call(container.children).forEach(function (child) {
          if (
            child.tagName !== 'DETAILS' &&
            child.tagName !== 'SUMMARY' &&
            !isQuestionElement(child, mode)
          ) {
            queue.push(child);
          }
        });
      }

      return fallback;
    }

    function buildAccordion(source) {
      if (!source || source.dataset.faqReady === 'true') return;

      var mode = source.dataset.faqQuestionStyle || 'auto';
      var container = findQuestionContainer(source, mode);

      if (!container) return;

      var children = Array.prototype.slice.call(container.children);
      var questionIndexes = [];

      children.forEach(function (child, index) {
        if (isQuestionElement(child, mode)) {
          questionIndexes.push(index);
        }
      });

      if (questionIndexes.length < 2) {
        return;
      }

      source.dataset.faqReady = 'true';

      var firstQuestionIndex = questionIndexes[0];
      var list = document.createElement('div');
      list.className = 'artist-policy__faq-list';

      container.insertBefore(list, children[firstQuestionIndex]);

      var currentItem = null;
      var currentAnswer = null;
      var itemCount = 0;

      children.slice(firstQuestionIndex).forEach(function (node) {
        if (isQuestionElement(node, mode)) {
          itemCount += 1;

          currentItem = document.createElement('details');
          currentItem.className = 'artist-policy__faq-item';

          var summary = document.createElement('summary');
          summary.className = 'artist-policy__faq-question';
          summary.textContent = node.textContent.trim();

          currentAnswer = document.createElement('div');
          currentAnswer.className = 'artist-policy__faq-answer rte';

          currentItem.appendChild(summary);
          currentItem.appendChild(currentAnswer);
          list.appendChild(currentItem);

          node.remove();
          return;
        }

        if (currentAnswer) {
          currentAnswer.appendChild(node);
        }
      });

      var items = Array.prototype.slice.call(
        list.querySelectorAll('.artist-policy__faq-item')
      );

      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;

          items.forEach(function (otherItem) {
            if (otherItem !== item && otherItem.open) {
              otherItem.open = false;
            }
          });
        });
      });

      if (source.dataset.faqOpenFirst === 'true' && items[0]) {
        items[0].open = true;
      }
    }

    function init(root) {
      (root || document)
        .querySelectorAll('[data-artist-policy-faq-source]')
        .forEach(buildAccordion);
    }

    function run() {
      init(document);
      window.setTimeout(function () {
        init(document);
      }, 250);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
      window.setTimeout(function () {
        init(event.target);
      }, 100);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artist-product-information"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initArtistProductEditorial(section) {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    var variantsDataEl = section.querySelector('[data-product-variants]');
        var variants = [];

        try {
          variants = JSON.parse(variantsDataEl.textContent);
        } catch (e) {
          console.error('Variant JSON error', e);
        }

        var form = section.querySelector('.artist-product-editorial__form');
        var optionSelects = Array.prototype.slice.call(section.querySelectorAll('[data-option-select]'));
        var optionButtons = Array.prototype.slice.call(section.querySelectorAll('[data-option-value]'));
        var variantInput = section.querySelector('[data-variant-id-input]');
    var priceWrap = section.querySelector('[data-product-price]');
    var skuWrap = section.querySelector('[data-product-sku]');
        var addButton = section.querySelector('[data-add-to-cart]');
        var mediaMainImage = section.querySelector('.artist-product-editorial__hero-image');
        var thumbButtons = Array.prototype.slice.call(section.querySelectorAll('[data-media-trigger]'));
        var qtyInput = section.querySelector('.artist-product-editorial__quantity-input');
        var qtyMinus = section.querySelector('[data-qty-minus]');
        var qtyPlus = section.querySelector('[data-qty-plus]');

    var defaultAddLabel = section.dataset.addLabel || 'Add to cart';
    var soldOutLabel = section.dataset.soldLabel || 'Sold out';
        var addingLabel = 'Holding this piece…';
        var addedLabel = 'Added to your collection';

        function money(cents) {
          if (window.Shopify && Shopify.formatMoney && section.dataset.moneyFormat) {
            return Shopify.formatMoney(cents, section.dataset.moneyFormat);
          }
          return '$' + (cents / 100).toFixed(2);
        }

        function normalizeOptionValue(value) {
          return String(value || '')
            .trim()
            .replace(/\s+/g, ' ');
        }

        function getSelectedOptions() {
          return optionSelects.map(function(select) {
            return normalizeOptionValue(select.value);
          });
        }

        function setSelectToExactValue(select, targetValue) {
          if (!select) return false;

          var normalizedTarget = normalizeOptionValue(targetValue);
          var matched = false;

          Array.prototype.slice.call(select.options).forEach(function(option) {
            if (matched) return;
            if (normalizeOptionValue(option.value) === normalizedTarget) {
              select.value = option.value;
              matched = true;
            }
          });

          return matched;
        }

        function findVariant() {
          var selected = getSelectedOptions();

          for (var i = 0; i < variants.length; i++) {
            var variant = variants[i];
            if (!variant.options || variant.options.length !== selected.length) continue;

            var isMatch = true;

            for (var j = 0; j < selected.length; j++) {
              if (normalizeOptionValue(variant.options[j]) !== selected[j]) {
                isMatch = false;
                break;
              }
            }

            if (isMatch) return variant;
          }

          return null;
        }

        function findVariantByMediaId(mediaId) {
          if (!mediaId) return null;

          for (var i = 0; i < variants.length; i++) {
            if (String(variants[i].featured_media_id) === String(mediaId)) {
              return variants[i];
            }
          }

          return null;
        }

        function findBestVariantForMedia(mediaId) {
          if (!mediaId) return null;

          var currentVariant = findVariant();
          var selected = getSelectedOptions();
          var bestVariant = null;
          var bestScore = -1;

          if (currentVariant && String(currentVariant.featured_media_id) === String(mediaId)) {
            return currentVariant;
          }

          for (var i = 0; i < variants.length; i++) {
            var variant = variants[i];
            if (String(variant.featured_media_id) !== String(mediaId)) continue;

            var score = 0;
            for (var j = 0; j < variant.options.length; j++) {
              if (normalizeOptionValue(variant.options[j]) === selected[j]) {
                score++;
              }
            }

            if (score > bestScore) {
              bestScore = score;
              bestVariant = variant;
            }
          }

          return bestVariant || findVariantByMediaId(mediaId);
        }

        function updateOptionButtons() {
          optionButtons.forEach(function(button) {
            button.classList.remove('is-active');
            button.setAttribute('aria-pressed', 'false');
          });

          optionSelects.forEach(function(select) {
            var index = String(select.getAttribute('data-option-index'));
            var selectedValue = normalizeOptionValue(select.value);

            optionButtons.forEach(function(button) {
              if (String(button.getAttribute('data-option-index')) !== index) return;

              var buttonValue = normalizeOptionValue(button.getAttribute('data-option-value'));
              if (buttonValue === selectedValue) {
                button.classList.add('is-active');
                button.setAttribute('aria-pressed', 'true');
              }
            });
          });
        }

        function applyVariantToOptions(variant) {
          if (!variant || !variant.options) return;

          optionSelects.forEach(function(select, index) {
            if (typeof variant.options[index] === 'undefined') return;
            setSelectToExactValue(select, variant.options[index]);
          });

          updateOptionButtons();
          updateUI(variant);
        }

        function setMainImage(src, srcset, full, alt) {
          if (mediaMainImage && src) {
            mediaMainImage.src = src;

            if (srcset) {
              mediaMainImage.srcset = srcset;
            } else {
              mediaMainImage.removeAttribute('srcset');
            }

            mediaMainImage.alt = alt || '';
          }
        }

        function activateMatchingThumb(mediaId) {
          thumbButtons.forEach(function(btn) {
            btn.classList.remove('is-active');
          });

          if (!mediaId) return;

          var matchingThumb = section.querySelector('[data-media-id="' + mediaId + '"]');
          if (matchingThumb) {
            matchingThumb.classList.add('is-active');
          }
        }

        function updateMediaByVariant(variant) {
          if (!variant) return;

          if (variant.featured_image && variant.featured_image.src) {
            setMainImage(
              variant.featured_image.src,
              variant.featured_image.srcset,
              variant.featured_image.full,
              variant.featured_image.alt
            );
          }

          activateMatchingThumb(variant.featured_media_id);
        }

        function updateUI(variant, options) {
          options = options || {};

          if (!variant) {
            if (addButton) {
              addButton.disabled = true;
              addButton.textContent = soldOutLabel;
            }
            return;
          }

          if (variantInput) {
            variantInput.value = variant.id;
          }

          if (priceWrap) {
            var compareHtml = '';
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              compareHtml = '<span class="artist-product-editorial__price-compare">' + money(variant.compare_at_price) + '</span>';
            }

            priceWrap.innerHTML =
              compareHtml +
              '<span class="artist-product-editorial__price-current">' + money(variant.price) + '</span>';
          }

          if (skuWrap) {
            skuWrap.textContent = variant.sku || '';
          }

          if (addButton) {
            addButton.disabled = !variant.available;
            addButton.textContent = variant.available ? defaultAddLabel : soldOutLabel;
          }

          if (options.updateMedia !== false) {
            updateMediaByVariant(variant);
          }

          if (options.updateUrl !== false && section.dataset.productUrl && window.history.replaceState) {
            var url = new URL(section.dataset.productUrl, window.location.origin);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          }
        }

        function triggerSelectChange(select) {
          var event;
          try {
            event = new Event('change', { bubbles: true });
          } catch (e) {
            event = document.createEvent('Event');
            event.initEvent('change', true, true);
          }
          select.dispatchEvent(event);
        }

        function refreshCartBubble() {
          fetch(window.Shopify.routes.root + 'cart.js', {
            headers: { Accept: 'application/json' }
          })
            .then(function(response) {
              return response.json();
            })
            .then(function(cart) {
              var count = cart.item_count;

              document.querySelectorAll(
                '.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble .count, [data-cart-count]'
              ).forEach(function(node) {
                node.textContent = count;
              });

              document.querySelectorAll('.cart-count-bubble').forEach(function(bubble) {
                if (count > 0) bubble.classList.remove('hidden');
                else bubble.classList.add('hidden');
              });

              return fetch(window.Shopify.routes.root + '?section_id=cart-icon-bubble');
            })
            .then(function(response) {
              return response.text();
            })
            .then(function(htmlText) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(htmlText, 'text/html');
              var newBubble = doc.querySelector('#cart-icon-bubble');
              var currentBubble = document.querySelector('#cart-icon-bubble');

              if (newBubble && currentBubble) {
                currentBubble.innerHTML = newBubble.innerHTML;
              }
            })
            .catch(function() {});
        }

        optionButtons.forEach(function(button) {
          button.addEventListener('click', function() {
            var optionIndex = String(button.getAttribute('data-option-index'));
            var rawValue = button.getAttribute('data-option-value');
            var select = section.querySelector('[data-option-select][data-option-index="' + optionIndex + '"]');

            if (!select) return;

            setSelectToExactValue(select, rawValue);
            triggerSelectChange(select);
          });
        });

        optionSelects.forEach(function(select) {
          select.addEventListener('change', function() {
            var variant = findVariant();
            updateOptionButtons();
            updateUI(variant);
          });
        });

        thumbButtons.forEach(function(button) {
          button.addEventListener('click', function() {
            var mediaId = button.getAttribute('data-media-id');
            var matchingVariant = findBestVariantForMedia(mediaId);

            if (matchingVariant) {
              applyVariantToOptions(matchingVariant);
              updateOptionButtons();
            } else {
              activateMatchingThumb(mediaId);
              setMainImage(
                button.getAttribute('data-media-src'),
                button.getAttribute('data-media-srcset'),
                button.getAttribute('data-media-full'),
                button.getAttribute('data-media-alt') || ''
              );
            }
          });
        });

        if (qtyMinus && qtyInput) {
          qtyMinus.addEventListener('click', function() {
            var step = parseInt(qtyInput.step || 1, 10);
            var min = parseInt(qtyInput.min || 1, 10);
            var value = parseInt(qtyInput.value || min, 10);
            qtyInput.value = Math.max(min, value - step);
          });
        }

        if (qtyPlus && qtyInput) {
          qtyPlus.addEventListener('click', function() {
            var step = parseInt(qtyInput.step || 1, 10);
            var value = parseInt(qtyInput.value || 1, 10);
            qtyInput.value = value + step;
          });
        }

        if (form) {
          form.addEventListener('submit', function(event) {
            event.preventDefault();

            var variant = findVariant();
            if (!variant || !variant.available) return;

            var quantity = qtyInput ? parseInt(qtyInput.value || 1, 10) : 1;
            if (!quantity || quantity < 1) quantity = 1;

            if (addButton) {
              addButton.disabled = true;
              addButton.textContent = addingLabel;
            }

            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: [
                  {
                    id: variant.id,
                    quantity: quantity
                  }
                ]
              })
            })
              .then(function(response) {
                if (!response.ok) throw new Error('Cart add failed');
                return response.json();
              })
              .then(function() {
                refreshCartBubble();

                document.dispatchEvent(new CustomEvent('cart:refresh'));
                document.dispatchEvent(new CustomEvent('cart:open'));

                if (addButton) {
                  addButton.textContent = addedLabel;
                }

                setTimeout(function() {
                  if (addButton) {
                    addButton.disabled = false;
                    addButton.textContent = defaultAddLabel;
                  }
                }, 1600);
              })
              .catch(function(error) {
                console.error(error);
                if (addButton) {
                  addButton.disabled = false;
                  addButton.textContent = defaultAddLabel;
                }
              });
          });
        }

        updateOptionButtons();

        // Keep the server-rendered, high-priority LCP image untouched on first load.
        // Liquid already rendered the correct selected variant, price, SKU and media.
        updateUI(findVariant(), {
          updateMedia: false,
          updateUrl: false
        });
      }

  function initializeArtistProducts(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('[data-artist-product-editorial]')) {
      initArtistProductEditorial(scope);
    }

    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-artist-product-editorial]'),
      initArtistProductEditorial
    );
  }

  function bootArtistProducts() {
    initializeArtistProducts(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootArtistProducts, { once: true });
  } else {
    bootArtistProducts();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initializeArtistProducts(event.target);
  });

  document.addEventListener('contextmenu', function(event) {
    if (event.target.closest('.no-save-wrap')) {
      event.preventDefault();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artist-product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('artist-product-recommendations')) return;

  customElements.define(
    'artist-product-recommendations',
    class ArtistProductRecommendations extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
        this.hasLoaded = false;
      }

      connectedCallback() {
        if (this.hasLoaded) return;

        if (!('IntersectionObserver' in window)) {
          this.loadRecommendations();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0] || !entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.loadRecommendations();
          },
          { rootMargin: '150px 0px' }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }

      loadRecommendations() {
        if (this.hasLoaded) return;

        const url = this.dataset.url;
        if (!url) return;

        this.hasLoaded = true;
        this.setAttribute('aria-busy', 'true');

        fetch(url)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Product recommendations request failed: ' + response.status);
            }
            return response.text();
          })
          .then((htmlText) => {
            const documentFragment = new DOMParser().parseFromString(htmlText, 'text/html');
            const recommendations =
              documentFragment.querySelector('artist-product-recommendations') ||
              documentFragment.querySelector('product-recommendations');

            if (!recommendations) return;

            const content = recommendations.innerHTML.trim();
            if (!content) return;

            this.innerHTML = content;
          })
          .catch((error) => {
            this.hasLoaded = false;
            console.error('Product recommendations failed to load', error);
          })
          .finally(() => {
            this.removeAttribute('aria-busy');
          });
      }
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["for-curators-artist-packet"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function playCuratorFilm(shell) {
      if (!shell || shell.dataset.playing === 'true') return;

      var youtubeId = shell.getAttribute('data-youtube-id');
      var title = shell.getAttribute('data-youtube-title') || 'YouTube video';

      if (!youtubeId) return;

      shell.dataset.playing = 'true';

      var iframe = document.createElement('iframe');
      iframe.className = 'curator-page__iframe';
      iframe.src =
        'https://www.youtube-nocookie.com/embed/' +
        encodeURIComponent(youtubeId) +
        '?autoplay=1&mute=1&playsinline=1&rel=0&modestbranding=1';
      iframe.title = title;
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allowFullscreen = true;

      shell.replaceChildren(iframe);
    }

    document.querySelectorAll('.curator-page').forEach(function (section) {
      var shell = section.querySelector('[data-curator-youtube-shell]');
      var poster = section.querySelector('.curator-page__film-poster');
      var playButton = section.querySelector('[data-curator-film-play-button]');

      if (poster) {
        poster.addEventListener('click', function () {
          playCuratorFilm(shell);
        }, { once: true });
      }

      if (playButton) {
        playButton.addEventListener('click', function () {
          playCuratorFilm(shell);
        }, { once: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["through-the-eyes-of-me-film-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function playFilm(shell) {
      if (!shell || shell.dataset.playing === 'true') return;

      var youtubeId = shell.getAttribute('data-youtube-id');
      var title = shell.getAttribute('data-youtube-title') || 'Through My Eyes';

      if (!youtubeId) return;

      shell.dataset.playing = 'true';

      var iframe = document.createElement('iframe');
      iframe.className = 'through-eyes-page__iframe';
      iframe.src =
        'https://www.youtube-nocookie.com/embed/' +
        encodeURIComponent(youtubeId) +
        '?autoplay=1&mute=1&playsinline=1&rel=0&modestbranding=1';
      iframe.title = title;

      /*
        Do not use loading="lazy" here.
        The iframe is only created after a user click, so lazy-loading it can
        delay the navigation that carries YouTube's autoplay request and can
        lead to an extra Play tap on some browsers.
      */
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allowFullscreen = true;

      shell.replaceChildren(iframe);
      iframe.focus();
    }

    document.querySelectorAll('.through-eyes-page').forEach(function (section) {
      var shell = section.querySelector('[data-through-eyes-youtube]');
      var poster = section.querySelector('.through-eyes-page__poster');
      var playButton = section.querySelector('[data-through-eyes-play-button]');

      if (poster) {
        poster.addEventListener('click', function () {
          playFilm(shell);
        }, { once: true });
      }

      if (playButton) {
        playButton.addEventListener('click', function () {
          playFilm(shell);
        }, { once: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
